import React from 'react'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import Stack from '@mui/material/Stack'
import { TppSection as TppSectionType, TppRow as TppRowType, TppCell, TppColumn, TppSlot } from '../types'
import TppRow from './TppRow'
import { ColumnVersionFull } from '../../TPPChangeLog/types'

interface TppSectionProps {
    section: TppSectionType
    rowMap: Record<string, TppRowType>
    slots: Record<string, TppSlot>
    cellLookup: Record<string, Record<string, TppCell>>
    columnIds: string[]
    pinnedIds: string[]
    columnsById: Record<string, TppColumn>
    cellsById: Record<string, TppCell>
    onAddSlot: (rowId: string) => void
    isAddingSlot?: boolean
    isSummary: boolean
    activeDragType: string | null
    activeCellSlotId: string | null
    visibleColumns: { id: string; label: string }[]
    creatingCellKey: string | null
    onCreateCell: (slotId: string, columnId: string) => Promise<void>
    movingCellId: string | null
    movingSlotId: string | null
    showContext: boolean
    onUpdateSlotContext: (slotId: string, context: string) => Promise<void>
    comparisonData?: ColumnVersionFull | null
    isArchivedTab?: boolean
    canEdit?: boolean
}

const TppSection: React.FC<TppSectionProps> = ({
    section,
    rowMap,
    slots,
    cellLookup,
    columnIds,
    pinnedIds,
    columnsById,
    cellsById,
    onAddSlot,
    isAddingSlot,
    isSummary,
    activeDragType,
    activeCellSlotId,
    visibleColumns,
    creatingCellKey,
    onCreateCell,
    movingCellId,
    movingSlotId,
    showContext,
    onUpdateSlotContext,
    comparisonData,
    isArchivedTab,
    canEdit = true,
}) => {
    return (
        <Stack direction="column" sx={{ zIndex: 5 }}>
            <SortableContext items={section.rowIds} strategy={verticalListSortingStrategy}>
                {section.rowIds.map((rowId, index) => (
                    <TppRow
                        key={rowId}
                        row={rowMap[rowId]}
                        slots={slots}
                        columnIds={columnIds}
                        cellLookup={cellLookup}
                        pinnedIds={pinnedIds}
                        columnsById={columnsById}
                        cellsById={cellsById}
                        onAddSlot={onAddSlot}
                        isAddingSlot={isAddingSlot}
                        isSummary={isSummary}
                        activeDragType={activeDragType}
                        activeCellSlotId={activeCellSlotId}
                        visibleColumns={visibleColumns}
                        creatingCellKey={creatingCellKey}
                        onCreateCell={onCreateCell}
                        movingCellId={movingCellId}
                        movingSlotId={movingSlotId}
                        showContext={showContext}
                        onUpdateSlotContext={onUpdateSlotContext}
                        isArchivedTab={isArchivedTab}
                        sectionTitle={index === 0 ? section.title : undefined}
                        comparisonData={comparisonData}
                        canEdit={canEdit}
                    />
                ))}
            </SortableContext>
        </Stack>
    )
}

export default TppSection
